@if (previousURL || url) {
    <button class="button-container mat-subtitle-2" (click)="goBack()" mat-button [color]="color">
        <mat-icon class="md-icon-24 m-0">arrow_left</mat-icon>
        &nbsp;<ng-content />
    </button>
}
